import { render, staticRenderFns } from "./Texte.vue?vue&type=template&id=56f1e1ce&"
import script from "./Texte.vue?vue&type=script&lang=js&"
export * from "./Texte.vue?vue&type=script&lang=js&"
import style0 from "./Texte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports